export default {
  root: {},
};
